import React, { useState, useEffect } from "react";

function FatPrices({ tableTitle }) {
  // Initializing the state based on the type of table (cow vs others)
  const initialFatPrices = (() => {
    const storedFatPrices = localStorage.getItem(`${tableTitle}_fatPrices`);
    if (storedFatPrices) {
      return JSON.parse(storedFatPrices);
    } else {
      if (tableTitle === "Cow") {
        return {
          below35: "",
          above35: "",
        };
      } else {
        return {
          fat100: "",
        };
      }
    }
  })();

  const [fatPrices, setFatPrices] = useState(initialFatPrices);
  const [isModalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    localStorage.setItem(`${tableTitle}_fatPrices`, JSON.stringify(fatPrices));
  }, [fatPrices]);

  // Handle input change for cow (below and above 3.5%)
  const handleCowPriceChange = (key, value) => {
    setFatPrices((prevPrices) => ({
      ...prevPrices,
      [key]: value,
    }));
  };

  // Handle input change for other animals (single input for 100% fat)
  const handleOtherPriceChange = (value) => {
    setFatPrices((prevPrices) => ({
      ...prevPrices,
      fat100: value,
    }));
  };

  return (
    <div className="max-w-lg mx-auto bg-white rounded-lg shadow-lg p-6 mt-8">
      <h2 className="text-lg font-bold mb-4 text-center">
        {tableTitle === "Cow" ? "Cow Fat Prices" : "Buffalo Fat Prices"}
      </h2>

      {tableTitle === "Cow" ? (
        // Cow-specific inputs for below and above 3.5%
        <div className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Price for fat below 3.5%:
            </label>
            <input
              type="number"
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-500"
              value={fatPrices.below35}
              onChange={(e) => handleCowPriceChange("below35", e.target.value)}
            />
          </div>
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Price for fat above 3.5%:
            </label>
            <input
              type="number"
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-500"
              value={fatPrices.above35}
              onChange={(e) => handleCowPriceChange("above35", e.target.value)}
            />
          </div>
        </div>
      ) : (
        // Other animals input for 100% fat
        <div className="space-y-4">
          <label className="block text-gray-700 font-medium mb-2">
            Price for 100% fat:
          </label>
          <input
            type="number"
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-500"
            value={fatPrices.fat100}
            onChange={(e) => handleOtherPriceChange(e.target.value)}
          />
        </div>
      )}

      <button
        className="mt-6 w-full bg-submit-active-nav text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-600 focus:ring focus:ring-blue-300"
        onClick={() => setModalVisible(true)}
      >
        Save
      </button>

      {isModalVisible && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <h3 className="text-xl font-bold mb-4">Entries Saved Successfully!</h3>
            <button
              className="mt-4 bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600"
              onClick={() => setModalVisible(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default FatPrices;
